import React from 'react'

function Loader() {
  return (
    <div>
        <div className='loader'></div>
    </div>
  )
}

export default Loader